import CustomSelect from "@/components/CustomSelect";
import ReactPaginate from "react-paginate";
import { ResultItem } from "@/components/DrmInformationSearch/ResultItem";
import React from "react";
import { DrmInformationHooks } from "@/types/drmInformation";

export const SearchResultsContainer = ( { drmInformationHooks }: { drmInformationHooks: DrmInformationHooks } ) => {
  return (
    <>
      <div className="drmInformation-search-sub-title uk-flex uk-flex-between margin-top-35" ref={drmInformationHooks.onClickSearchScrollRef}>
        <p className="uk-drmInformation-text-medium-l uk-text-bold">
          検索結果：{drmInformationHooks.displayDrmInformationList.length}件中 {drmInformationHooks.firstItemNum + 1}~{drmInformationHooks.lastItemNum}件目
        </p>
        <div className="uk-flex uk-flex-middle">
          <p className="uk-text-default uk-text-bold" translate="no">表示件数：</p>
          <CustomSelect
            options={pageSizeOptions}
            value={drmInformationHooks.pageSize}
            onChange={drmInformationHooks.onChangePageSize}
            className="height-24"
          />
          <p className="uk-text-default uk-text-bold uk-margin-small-left">
            並び順：
          </p>
          <CustomSelect
            options={[{ value: "1", label: "公開日" }, { value: "2", label: "閲覧数" }]}
            value={drmInformationHooks.order}
            onChange={e => drmInformationHooks.setOrder(e.target.value)}
            className="height-24"
          />
        </div>
      </div>
      <div className="uk-flex uk-flex-center@m uk-margin-small-top uk-margin-small-bottom">
        <a className="pagination-button" onClick={drmInformationHooks.goToFirstPage}>&lt;&lt;</a>
        <ReactPaginate
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={Math.ceil(drmInformationHooks.displayDrmInformationList.length / Number(drmInformationHooks.pageSize))}
          onPageChange={drmInformationHooks.onChangePage}
          forcePage={String(drmInformationHooks.currentPage).length > 0 ? drmInformationHooks.currentPage : undefined}
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
        />
        <a className="pagination-button" onClick={drmInformationHooks.goToLastPage}>&gt;&gt;</a>
      </div>
      <div className="drmInformation-search-result">
        {drmInformationHooks.currentDrmInformationList.map(( drmInformation, index ) => <ResultItem drmInformation={drmInformation} index={index} key={index}/>)}
      </div>
      <div className="uk-flex uk-flex-center@m uk-margin-small-top">
        <a className="pagination-button" onClick={drmInformationHooks.goToFirstPage}>&lt;&lt;</a>
        <ReactPaginate
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={Math.ceil(drmInformationHooks.displayDrmInformationList.length / Number(drmInformationHooks.pageSize))}
          onPageChange={drmInformationHooks.onChangePage}
          forcePage={String(drmInformationHooks.currentPage).length > 0 ? drmInformationHooks.currentPage : undefined}
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          previousLabel="<"
          nextLabel=">"
          breakLabel="..."
        />
        <a className="pagination-button" onClick={drmInformationHooks.goToLastPage}>&gt;&gt;</a>
      </div>
    </>
  )
}


const pageSizeOptions = [
  { value: "10", label: "10件" },
  { value: "20", label: "20件" },
  { value: "50", label: "50件" },
  { value: "100", label: "100件" }
]